<template>
  <!-- 剧集抽屉 -->
  <a-drawer title="充值说明" width="700" :closable="false" :visible="visible" @close="onClose"
    :footer-style="{ textAlign: 'right' }">
    <a-form ref="RefForm" :model="formState" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
      <!-- 模块名称 -->
      <a-form-item label="模块名称" name="name" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model:value="formState.name" placeholder="请输入" />
      </a-form-item>
      <!-- 说明内容 -->
      <a-form-item label="说明内容" name="description" :rules="[{ required: true, message: '请输入' }]">
        <a-textarea v-model:value="formState.description" placeholder="请输入" :maxLength="1000" :rows="4" />
      </a-form-item>
    </a-form>


    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import Loading from '@/components/Loading'
import Pub from '@/utils/public'
import { dramaDetail, dramaEdit } from '@/api/appfront'
import { cashRechargeDescSave } from '@/api/appfront'

const emit = defineEmits('success')
// Form实例
const RefForm = ref(null)
// 抽屉展示状态
let visible = ref(false)
// 加载
let isLoading = ref(false)
// name
let id = ref(undefined)
// 剧集信息
let formState = reactive({
  // 模块名称
  name: undefined,
  // 说明内存
  description: undefined,
})

// 打开抽屉
function showDrawer(record) {
  visible.value = true
  id.value = record.id
  formState.name = record.recharge_name
  formState.description = record.recharge_content
  // 获取详情
  // getDetail()
}

// 获取详情
function getDetail() {
  dramaDetail({ id: id.value }).then(res => {
    const { code, data } = res
    if (code === 0) {
      let info = data.info
      formState.name = info.drama.name
      formState.description = info.description
    }
  })
}

// 关闭抽屉
function onClose() {
  if (!isLoading.value) {
    RefForm.value.resetFields()
    visible.value = false
    formState.name = undefined
    formState.description = undefined
  }
}

// 提交
function touchSubmit() {
  RefForm.value.validate().then((() => {
    isLoading.value = true
    // 准备数据
    const params = {
      id: id.value,
      recharge_name: formState.name,
      recharge_content: formState.description,
    }
    cashRechargeDescSave(params).then(res => {
      console.log(res);

      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        // 动态渲染后端返回的数据
        formState.name = data.recharge_name
        formState.description = data.recharge_content

        message.success('保存成功')
        onClose()
        emit('success')
      } else {
        message.error(res.message || msg)
      }
    })
  }))
}

// 暴露出去
defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped></style>